
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Review, ReviewState } from './rate';
import { deleteReview, fetchReviews, submitReview, getRatingStats } from './rateThunks';

const initialState: ReviewState = {
  reviews: [],
  allReviews: { reviews: [], pagination: { total: 0, page: 1, limit: 10, pages: 1 }, stats: { averageRating: 0, totalReviews: 0 } },
  loading: false,
  error: null,
  success: false,
};
// Slice
const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    resetReviewState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // Submit review
    builder
      .addCase(submitReview.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitReview.fulfilled, (state, action: PayloadAction<Review>) => {
        state.loading = false;
        state.success = true;
        state.reviews.unshift(action.payload);
      })
      .addCase(submitReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });

    // Fetch reviews
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchReviews.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.allReviews = action.payload;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
        state.success = false;
      });

    // Fetch rating stats
    builder
      .addCase(getRatingStats.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getRatingStats.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(getRatingStats.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });

    // Delete review
    builder
      .addCase(deleteReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteReview.fulfilled, (state, action: PayloadAction<string>) => {
        state.loading = false;
        state.reviews = state.reviews.filter(
          (review) => review.id !== action.payload
        );
      })
      .addCase(deleteReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { clearError, clearSuccess, resetReviewState } = reviewSlice.actions;
export default reviewSlice.reducer;